import { useLanguage } from "../contexts/LanguageContext";

export default function Cookies() {
  const { t } = useLanguage();

  return (
    <main data-testid="cookies-page" className="pt-28 pb-24 bg-[#0a0f1f]">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <h1 className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-12">
          {t("footer.cookies")}
        </h1>

        <div className="prose-dark font-outfit text-[#94a3b8] leading-relaxed space-y-8 text-sm md:text-base">
          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">1. ¿Qué son las cookies?</h2>
            <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario (ordenador, teléfono móvil, tablet) cuando los visita. Permiten que el sitio web recuerde información sobre su visita, como sus preferencias de idioma, para facilitarle la navegación y hacer que el sitio sea más útil.</p>
            <p className="mt-4">Además de las cookies propiamente dichas, este sitio utiliza tecnologías de almacenamiento local del navegador (localStorage y sessionStorage) con finalidades similares.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">2. Cookies y almacenamiento utilizados en este sitio</h2>
            <p>A continuación se detallan las cookies y mecanismos de almacenamiento local utilizados en medsim.es:</p>

            <div className="mt-6 overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-[#2a3449]">
                    <th className="py-3 pr-4 text-[#f8f9fa] font-medium text-sm">Nombre</th>
                    <th className="py-3 pr-4 text-[#f8f9fa] font-medium text-sm">Tipo</th>
                    <th className="py-3 pr-4 text-[#f8f9fa] font-medium text-sm">Finalidad</th>
                    <th className="py-3 pr-4 text-[#f8f9fa] font-medium text-sm">Duración</th>
                    <th className="py-3 text-[#f8f9fa] font-medium text-sm">Propietario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-[#2a3449]/50">
                    <td className="py-3 pr-4 text-xs font-mono">medsim_lang</td>
                    <td className="py-3 pr-4 text-xs">Preferencia</td>
                    <td className="py-3 pr-4 text-xs">Almacena el idioma seleccionado por el usuario (ES/EN/DE)</td>
                    <td className="py-3 pr-4 text-xs">Persistente (localStorage)</td>
                    <td className="py-3 text-xs">Propia</td>
                  </tr>
                  <tr className="border-b border-[#2a3449]/50">
                    <td className="py-3 pr-4 text-xs font-mono">medboard_cookie_consent</td>
                    <td className="py-3 pr-4 text-xs">Técnica</td>
                    <td className="py-3 pr-4 text-xs">Registra si el usuario ha aceptado o rechazado las cookies a través del banner de consentimiento</td>
                    <td className="py-3 pr-4 text-xs">Persistente (localStorage)</td>
                    <td className="py-3 text-xs">Propia</td>
                  </tr>
                  <tr className="border-b border-[#2a3449]/50">
                    <td className="py-3 pr-4 text-xs font-mono">medboard_admin</td>
                    <td className="py-3 pr-4 text-xs">Técnica</td>
                    <td className="py-3 pr-4 text-xs">Mantiene la sesión de administración activa durante la visita</td>
                    <td className="py-3 pr-4 text-xs">Sesión (sessionStorage, se elimina al cerrar el navegador)</td>
                    <td className="py-3 text-xs">Propia</td>
                  </tr>
                  <tr className="border-b border-[#2a3449]/50">
                    <td className="py-3 pr-4 text-xs font-mono">PostHog</td>
                    <td className="py-3 pr-4 text-xs">Analítica</td>
                    <td className="py-3 pr-4 text-xs">Recopilación de datos de uso y analítica web para mejorar el servicio</td>
                    <td className="py-3 pr-4 text-xs">Variable según cookie específica</td>
                    <td className="py-3 text-xs">Tercero (PostHog Inc.)</td>
                  </tr>
                  <tr className="border-b border-[#2a3449]/50">
                    <td className="py-3 pr-4 text-xs font-mono">YouTube (nocookie)</td>
                    <td className="py-3 pr-4 text-xs">Funcional / Tercero</td>
                    <td className="py-3 pr-4 text-xs">Los vídeos embebidos se sirven a través de youtube-nocookie.com, una versión que limita el seguimiento. Puede instalar cookies al reproducir un vídeo.</td>
                    <td className="py-3 pr-4 text-xs">Variable</td>
                    <td className="py-3 text-xs">Tercero (Google LLC)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">3. Base jurídica del uso de cookies</h2>
            <p>Las cookies técnicas y de preferencia se utilizan sobre la base del interés legítimo del responsable para el correcto funcionamiento del sitio web (art. 6.1.f del RGPD).</p>
            <p className="mt-4">Las cookies de analítica y de terceros se utilizan sobre la base del consentimiento del usuario (art. 6.1.a del RGPD), otorgado a través del banner de consentimiento que se muestra en la primera visita al sitio web.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">4. Gestión de preferencias de cookies</h2>
            <p>El usuario puede gestionar sus preferencias de cookies de las siguientes formas:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong className="text-[#f8f9fa]">Banner de consentimiento:</strong> Al acceder por primera vez al sitio, se muestra un banner que permite aceptar o rechazar las cookies. Esta preferencia queda registrada para futuras visitas.</li>
              <li><strong className="text-[#f8f9fa]">Configuración del navegador:</strong> La mayoría de los navegadores permiten gestionar las cookies a través de sus opciones de configuración. El usuario puede bloquear o eliminar cookies en cualquier momento, aunque esto puede afectar al funcionamiento del sitio web.</li>
              <li><strong className="text-[#f8f9fa]">Eliminar datos de almacenamiento local:</strong> Los datos almacenados mediante localStorage y sessionStorage pueden eliminarse desde las herramientas de desarrollador del navegador o borrando los datos del sitio.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">5. Cómo retirar o modificar el consentimiento</h2>
            <p>Para retirar el consentimiento otorgado, el usuario puede eliminar los datos de almacenamiento del sitio desde la configuración de su navegador. Al hacerlo, el banner de consentimiento volverá a mostrarse en su siguiente visita, permitiéndole modificar su elección.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">6. Cookies de terceros</h2>
            <p>Este sitio web utiliza servicios de terceros que pueden instalar sus propias cookies:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong className="text-[#f8f9fa]">PostHog (PostHog Inc.):</strong> Servicio de analítica web utilizado para comprender cómo los usuarios interactúan con el sitio. Más información en <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#1a6cf5] hover:underline">posthog.com/privacy</a>.</li>
              <li><strong className="text-[#f8f9fa]">YouTube (Google LLC):</strong> Los vídeos se embeben a través de youtube-nocookie.com, un dominio de YouTube diseñado para limitar el seguimiento. No obstante, al reproducir un vídeo pueden instalarse cookies por parte de Google. Más información en <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#1a6cf5] hover:underline">policies.google.com/privacy</a>.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">7. Más información</h2>
            <p>Para cualquier consulta sobre el uso de cookies en este sitio web, puede contactar con nosotros a través de <a href="mailto:info@sitayag.com" className="text-[#1a6cf5] hover:underline">info@sitayag.com</a>.</p>
          </section>

          <p className="text-[#64748b] text-xs mt-12">Última actualización: Junio 2026</p>
        </div>
      </div>
    </main>
  );
}
